<template>
    <vue-scroll class="page-edit-invoice-lines">
        <div class="page-header">
            <h1>Edit Order Confirmation Lines</h1>
        </div>
        <el-form style="max-width: 800px">
            <table class="w-full table-custom-invoice-lines">
                <thead>
                    <tr>
                        <th style="width: 50px">Quantity</th>
                        <th style="width: 100px">SKU</th>
                        <th>Description</th>
                        <th style="width: 100px">Total</th>
                        <th style="width: 100px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(line, i) in form.invoice_lines">
                        <td>
                            <el-form-item
                                :class="
                                    form.state(`invoice_lines.${i}.quantity`)
                                "
                                class="mb-0"
                                required
                            >
                                <el-input
                                    :name="`invoice_lines.${i}.price`"
                                    :step="1"
                                    data-vv-as="quantity"
                                    type="number"
                                    v-model="line.quantity"
                                    v-validate="'required'"
                                />
                                <form-feedback
                                    :field="`invoice_lines.${i}.quantity`"
                                    :form="form"
                                />
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item
                                :class="form.state(`invoice_lines.${i}.sku`)"
                                class="mb-0"
                            >
                                <el-input
                                    :name="`invoice_lines.${i}.sku`"
                                    data-vv-as="sku"
                                    v-model="line.sku"
                                />
                                <form-feedback
                                    :field="`invoice_lines.${i}.sku`"
                                    :form="form"
                                />
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item
                                :class="
                                    form.state(`invoice_lines.${i}.description`)
                                "
                                class="mb-0"
                                required
                            >
                                <el-input
                                    :name="`invoice_lines.${i}.description`"
                                    data-vv-as="description"
                                    v-model="line.description"
                                    v-validate="'required'"
                                />
                                <form-feedback
                                    :field="`invoice_lines.${i}.description`"
                                    :form="form"
                                />
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item
                                :class="form.state(`invoice_lines.${i}.total`)"
                                class="mb-0"
                                required
                            >
                                <el-input
                                    :name="`invoice_lines.${i}.total`"
                                    :step="0.01"
                                    data-vv-as="total"
                                    type="number"
                                    v-model="line.total"
                                    v-validate="'required'"
                                />
                                <form-feedback
                                    :field="`invoice_lines.${i}.total`"
                                    :form="form"
                                />
                            </el-form-item>
                        </td>
                        <td>
                            <el-button
                                @click="deleteLine(line)"
                                class="mt-10"
                                icon="mdi mdi-delete"
                                round
                                size="small"
                                type="danger"
                                >Delete
                            </el-button>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <el-button
                                :disabled="form.busy"
                                @click="addLine()"
                                icon="mdi mdi-plus"
                                round
                                type="primary"
                                >Add Line
                            </el-button>
                            <el-button
                                :loading="form.busy"
                                @click="submit()"
                                icon="mdi mdi-content-save"
                                round
                                type="success"
                                >Save Changes
                            </el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </el-form>
        <pdf-preview
            :url="previewUrl"
            class="mt-20"
            ref="pdfPreview"
        ></pdf-preview>
    </vue-scroll>
</template>

<script>
import PdfPreview from "@/components/PdfPreview";
import InvoiceLineTypes from "@/constants/invoice-line-types";

function getData(params) {
    return axios.get(`/web-api/order/${params.id}/invoice-line`, {
        params: {
            all: 1,
        },
    });
}

export default {
    beforeRouteEnter(to, from, next) {
        getData(to.params).then((response) => {
            next((vm) => {
                vm.setData(response);
            });
        });
    },
    components: {
        PdfPreview,
    },
    data() {
        return {
            form: new Form({
                invoice_lines: [],
            }),
        };
    },
    mounted() {
        this.form.setVeeErrors(this.veeErrors);
    },
    computed: {
        previewUrl() {
            return `/web-api/order/${this.$route.params.id}/download-invoice`;
        },
    },
    methods: {
        getData() {
            getData(this.$route.params).then((response) => {
                this.setData(response);
            });
        },
        setData(response) {
            this.form.invoice_lines = [];
            response.data.data.forEach((line) => {
                this.form.invoice_lines.push(
                    _.pick(line, [
                        "id",
                        "type",
                        "description",
                        "quantity",
                        "sku",
                        "total",
                    ])
                );
            });
        },
        addLine() {
            this.form.invoice_lines.push({
                id: null,
                type: InvoiceLineTypes.CUSTOM_LINE,
                description: null,
                quantity: 1,
                sku: null,
                total: null,
            });
        },
        submit() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    return;
                }
                App.put(
                    `/web-api/order/${this.$route.params.id}`,
                    this.form
                ).then(() => {
                    this.$notify.success({
                        message: "Changes have been saved.",
                    });
                    this.getData();
                    this.$refs.pdfPreview.update();
                });
            });
        },
        deleteLine(line) {
            Utils.arrayDelete(this.form.invoice_lines, line);
        },
    },
};
</script>

<style scoped></style>
